// Text links between a credit note and the invoice it credits (Oct 8 2026,
// approved text-only change). Chamber Member Pro's Manage Invoices
// (chamber-member-pro invoiceCreditLinks.ts) uses the same wording. Keep the
// copies identical. Each link is its own short line so it never wraps in the
// narrow Status column.

/** Credit note row link line, for example "For #101". */
export const getCreditNoteRowLinkLines = (creditForInvoiceNumber?: string | null): string[] => {
  const sourceNumber = creditForInvoiceNumber?.trim();
  return sourceNumber ? [`For #${sourceNumber}`] : [];
};

/** Source invoice row link lines, for example ["Credited by #200", "Credited by #233"]. */
export const getCreditedByRowLinkLines = (creditedByInvoiceNumbers?: readonly string[] | null): string[] =>
  (creditedByInvoiceNumbers || []).map(invoiceNumber => invoiceNumber.trim()).filter(Boolean)
    .map(invoiceNumber => `Credited by #${invoiceNumber}`);
